export default __webpack_public_path__ + "images/98a5d0492408247cae647acbd1fd2e81.jpeg";